if (!customElements.get('ds-trust-bar')) {
  class DsTrustBar extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        swiper: '.ds-tb__slider',
        toggle: '[data-ds-tb-toggle]',
      };
      this.swiper = null;
      this.mql = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
      this.initSlider();
    }

    syncMobileStaticSlide(swiperEl) {
      if (!swiperEl) return;

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const staticEl = this.querySelector('.ds-tb__static');
      if (!wrapper || !staticEl) return;

      const shouldHaveMobileStatic = !!(this.mql && this.mql.matches);
      const existing = wrapper.querySelector('.ds-tb__slide--static.swiper-slide');

      if (shouldHaveMobileStatic && !existing) {
        const slide = document.createElement('div');
        slide.className = 'ds-tb__slide ds-tb__slide--static swiper-slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');

        const inner = document.createElement('div');
        inner.className = 'ds-tb__mobile-static';
        inner.innerHTML = staticEl.innerHTML;

        slide.appendChild(inner);
        wrapper.insertBefore(slide, wrapper.firstChild);
      }

      if (!shouldHaveMobileStatic && existing) {
        existing.remove();
      }
    }

    initSlider() {
      const swiperEl = this.querySelector(this.selectors.swiper);
      if (!swiperEl) return;

      if (!window.Swiper) {
        return setTimeout(() => this.initSlider(), 100);
      }

      // Mobile-only: static (stars + title) becomes a rotating slide.
      // Desktop: static stays on the left and never disappears.
      this.syncMobileStaticSlide(swiperEl);

      const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

      if (slidesCount <= 1) {
        const toggle = this.querySelector(this.selectors.toggle);
        if (toggle) toggle.style.display = 'none';
        return;
      }

      const autoplay = swiperEl.dataset.autoplay === 'true';
      const delay = parseInt(swiperEl.dataset.autoplaySpeed, 10) || 5000;

      this.swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 500,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: autoplay
          ? { delay: delay, disableOnInteraction: false }
          : false,
        on: {
          afterInit: function () {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                swiperEl.classList.add('is-ready');
              });
            });
          },
        },
      });

      const toggle = this.querySelector(this.selectors.toggle);
      const labelPlay = this.dataset.labelPlay || 'Play';
      const labelPause = this.dataset.labelPause || 'Pause';

      if (toggle) {
        toggle.dataset.state = autoplay ? 'playing' : 'paused';
        toggle.addEventListener('click', () => {
          if (toggle.dataset.state === 'playing') {
            this.swiper.autoplay.stop();
            toggle.dataset.state = 'paused';
            toggle.setAttribute('aria-pressed', 'false');
            toggle.setAttribute('aria-label', labelPlay);
          } else {
            this.swiper.autoplay.start();
            toggle.dataset.state = 'playing';
            toggle.setAttribute('aria-pressed', 'true');
            toggle.setAttribute('aria-label', labelPause);
          }
        });
      }

      // If viewport changes, ensure the static slide exists ONLY on mobile.
      if (this.mql && !this.mql.__dsTbBound) {
        const onChange = () => {
          this.syncMobileStaticSlide(swiperEl);
          if (this.swiper && typeof this.swiper.update === 'function') {
            this.swiper.update();
          }
        };

        if (typeof this.mql.addEventListener === 'function') this.mql.addEventListener('change', onChange);
        else if (typeof this.mql.addListener === 'function') this.mql.addListener(onChange);
        this.mql.__dsTbBound = true;
      }
    }
  }

  customElements.define('ds-trust-bar', DsTrustBar);
}
